export default "__VITE_ASSET__DnM2j8vB__"